export const moduleName = 'contact-us';
